import { BRAND, CARD_COLORS } from "../constants";

var sampleTribute = {
  teacher: "Mrs. Appleby",
  from: "The Dengler Family",
  message: "Thank you for making every day special for our kids!",
  school: "Oakhurst Elementary",
  variant: 0,
};

var colors = CARD_COLORS[0];

function BaseCard({ children, style }) {
  return (
    <div style={{
      background: colors.bg,
      border: "1px solid " + colors.border,
      borderRadius: "6px",
      padding: "22px 26px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06), 1px 2px 4px rgba(0,0,0,0.04)",
      transform: "rotate(-1.2deg)",
      position: "relative",
      overflow: "hidden",
      ...style,
    }}>
      {children}
      <div style={{ lineHeight: 1.5 }}>
        <div style={{ fontSize: "13.5px", color: "#555" }}>
          To: <span style={{ color: "#333", fontWeight: 600 }}>{sampleTribute.teacher}</span>
        </div>
        <div style={{ fontSize: "13.5px", color: "#555" }}>
          From: <span style={{ color: "#333" }}>{sampleTribute.from}</span>
        </div>
      </div>
      <div style={{
        fontFamily: "'Caveat', cursive",
        fontSize: "22px",
        fontWeight: 500,
        color: "#1A1A1A",
        lineHeight: 1.3,
      }}>
        {sampleTribute.message}
      </div>
      <div style={{ fontSize: "11px", color: "#BBB" }}>{sampleTribute.school}</div>
    </div>
  );
}

function OptionA() {
  return (
    <BaseCard style={{
      boxShadow: "0 0 12px rgba(242,182,48,0.35), 0 0 4px rgba(242,182,48,0.2), 0 2px 8px rgba(0,0,0,0.06)",
      border: "1.5px solid " + BRAND.gold,
    }}>
      <div style={{
        position: "absolute",
        top: "8px",
        right: "8px",
        background: BRAND.gold,
        color: "#fff",
        fontSize: "10px",
        fontWeight: 700,
        padding: "2px 8px",
        borderRadius: "10px",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      }}>
        New
      </div>
    </BaseCard>
  );
}

function OptionB() {
  return (
    <BaseCard style={{
      border: "1.5px solid " + BRAND.gold,
    }}>
      <div style={{
        position: "absolute",
        top: "8px",
        right: "8px",
        background: BRAND.gold,
        color: "#fff",
        fontSize: "10px",
        fontWeight: 700,
        padding: "2px 8px",
        borderRadius: "10px",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        zIndex: 1,
      }}>
        New
      </div>
      <div style={{
        position: "absolute",
        top: 0,
        left: "-100%",
        width: "100%",
        height: "100%",
        background: "linear-gradient(90deg, transparent, " + colors.shimmer + ", transparent)",
        animation: "shimmer 2.5s ease-in-out infinite",
      }} />
      <style>{`
        @keyframes shimmer {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}</style>
    </BaseCard>
  );
}

function OptionC() {
  return (
    <BaseCard style={{
      boxShadow: "0 0 0 2px " + BRAND.gold + "40, 0 2px 8px rgba(0,0,0,0.06)",
      animation: "pulseGlow 2s ease-in-out infinite",
    }}>
      <div style={{
        position: "absolute",
        top: "8px",
        right: "8px",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        background: BRAND.gold,
        animation: "pulseDot 1.5s ease-in-out infinite",
      }} />
      <style>{`
        @keyframes pulseGlow {
          0%, 100% { box-shadow: 0 0 0 2px rgba(242,182,48,0.25), 0 2px 8px rgba(0,0,0,0.06); }
          50% { box-shadow: 0 0 0 3px rgba(242,182,48,0.4), 0 0 16px rgba(242,182,48,0.15), 0 2px 8px rgba(0,0,0,0.06); }
        }
        @keyframes pulseDot {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.3); }
        }
      `}</style>
    </BaseCard>
  );
}

export default function NewTributePoc() {
  return (
    <div style={{ minHeight: "100vh", background: BRAND.warm, fontFamily: "'DM Sans', sans-serif", padding: "40px 20px" }}>
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <h1 style={{ fontSize: "22px", fontWeight: 700, color: BRAND.text, margin: "0 0 4px", textAlign: "center" }}>
          New Tribute Effects — POC
        </h1>
        <p style={{ fontSize: "13px", color: BRAND.textLight, textAlign: "center", margin: "0 0 40px" }}>
          Tributes created within the last 24 hours. Sorted newest first.
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "40px" }}>
          <div>
            <h3 style={{ fontSize: "14px", fontWeight: 600, color: BRAND.text, margin: "0 0 4px", textAlign: "center" }}>A: Gold Glow + Badge</h3>
            <p style={{ fontSize: "12px", color: BRAND.textLight, textAlign: "center", margin: "0 0 16px" }}>
              Gold border, soft glow, &ldquo;New&rdquo; pill badge
            </p>
            <OptionA />
          </div>
          <div>
            <h3 style={{ fontSize: "14px", fontWeight: 600, color: BRAND.text, margin: "0 0 4px", textAlign: "center" }}>B: Shimmer Sweep</h3>
            <p style={{ fontSize: "12px", color: BRAND.textLight, textAlign: "center", margin: "0 0 16px" }}>
              Gold border, light sweep animation
            </p>
            <OptionB />
          </div>
          <div>
            <h3 style={{ fontSize: "14px", fontWeight: 600, color: BRAND.text, margin: "0 0 4px", textAlign: "center" }}>C: Pulse Glow + Dot</h3>
            <p style={{ fontSize: "12px", color: BRAND.textLight, textAlign: "center", margin: "0 0 16px" }}>
              Breathing gold ring, pulsing dot indicator
            </p>
            <OptionC />
          </div>
        </div>

        <div style={{ marginTop: "48px", textAlign: "center" }}>
          <h3 style={{ fontSize: "14px", fontWeight: 600, color: BRAND.text, margin: "0 0 16px" }}>For comparison — a normal card:</h3>
          <div style={{ maxWidth: "300px", margin: "0 auto" }}>
            <BaseCard />
          </div>
        </div>
      </div>
    </div>
  );
}
